import React from 'react';
import { withModalStepsContext } from "./ModalStepsContext";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ModalStep = withModalStepsContext(_ref => {
  var {
    activeStep
  } = _ref;
  return ___EmotionJSX(React.Fragment, null, activeStep.content);
});